// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1406": "2fafa60e","4071": "8700404f","5163": "2398fa60",}[chunkId] + ".css"
}